import me from "models/me";
export default function (nextState, replace, callback) {
    const { accesstoken } = nextState.location.query;
    if (!me.isSignedIn() && !accesstoken) {
        if (
            nextState.params &&
            nextState.params.brand &&
            nextState.params.splat &&
            nextState.params.splat === "custom-login"
        ) {
            // Replace with alternate login if it exists
            replace({ pathname: `/${nextState.params.brand}` });
        } else {
            const redirectPath = nextState.location.pathname + (nextState.location.search || "");
            replace({
                pathname: "/login",
                query: { redirect: redirectPath },
            });
        }
    }
    callback();
}
